import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Filtro } from '../../shared/models/filtro.model';
import { Pessoa } from '../../shared/models/pessoa.model';
import { ViewModelWebContratoEmp } from '../../shared/models/viewModelWebContratoEmp.model';
import { WebContratoEmp } from '../../shared/models/webContratoEmp.model';
import { PessoaService } from '../../shared/services/pessoa.service';
import { WebContratoEmpService } from '../../shared/services/webContratoEmp.Service';
import { WebProcessoControleService } from '../../shared/services/webProcessoControle.service';
import { LoginStore } from '../../shared/store/login.store';
import { ViewModelMovimentacaoEmp } from '../../shared/models/viewModelMovimentacaoEmp.model';

@Component({
    selector: 'app-detalhes-emprestimo',
    templateUrl: './detalhes-emprestimo.component.html',
    styleUrls: ['./detalhes-emprestimo.component.scss']
})
export class DetalhesEmprestimoComponent implements OnInit {
    idProcesso: number;
    tabIndex: number = 0;
    filtro: Filtro = new Filtro();
    desabilitaBotaoDeferir: boolean = true;
    webContratoEmp: WebContratoEmp = new WebContratoEmp();
    pessoa: Pessoa = new Pessoa();
    viewModelWebContratoEmp: ViewModelWebContratoEmp = new ViewModelWebContratoEmp();
    viewModelMovimentacaoEmp: ViewModelMovimentacaoEmp = new ViewModelMovimentacaoEmp();
    isButtonVisible = true;
    loading = false;
    idPessoaLogada: number;
    nmPessoaConcessaoCancelamento: string;
    dataAtual: Date = new Date();
    dataFormatada: string;
    dataFormatadaCredito: string;
    constructor(private readonly webContratoEmpService: WebContratoEmpService,
        private readonly webProcessoControleService: WebProcessoControleService,
        private _snackBar: MatSnackBar,
        private loginStore: LoginStore,
        private pessoaService: PessoaService) {

        this.loginStore.getCurrent().subscribe(retorno => {
            this.idPessoaLogada = retorno.idPessoa;
            console.log('id pessoa logada', this.idPessoaLogada);
        });
        this.filtro = JSON.parse(sessionStorage.getItem('detalhesEmprestimoDados'));


        this.buscaContrato();

    }


    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ['mat-toolbar', 'mat-success']
        });
    }

    openSnackBarError(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ['mat-toolbar', 'mat-warn']
        });
    }
    buscaContrato() {
        this.loading = true;
        this.webContratoEmpService.getContratosByPessoa(this.filtro.idContrato).subscribe(retorno => {
            if (retorno) {
                console.log('retorno contratos', retorno);
                this.desabilitaBotaoDeferir = false;
                this.viewModelWebContratoEmp = retorno;

                if (this.viewModelWebContratoEmp.webContratoEmp.idPessoaConcessao > 0 && this.viewModelWebContratoEmp.webContratoEmp.status == 1) {
                    this.buscaPessoa(this.viewModelWebContratoEmp.webContratoEmp.idPessoaConcessao);
                }
                if (this.viewModelWebContratoEmp.webContratoEmp.idPessoaCancelado > 0 && this.viewModelWebContratoEmp.webContratoEmp.status == 2) {
                    this.buscaPessoa(this.viewModelWebContratoEmp.webContratoEmp.idPessoaCancelado);
                }
                if (this.viewModelWebContratoEmp.webContratoEmp.idPessoaCancelado === 0 && this.viewModelWebContratoEmp.webContratoEmp.status == 2) {
                    this.buscaPessoa(this.viewModelWebContratoEmp.webContratoEmp.idPessoa);
                }

                this.loading = false;
            }
        }, error => {
            this.loading = false;
            this.openSnackBarError("Erro ao buscar os dados do participante!" + error, 'X');
        });
    }

    buscaPessoa(idPessoa: number) {
        this.pessoaService.getById(idPessoa).subscribe(pessoa => {
            if (pessoa) {
                this.nmPessoaConcessaoCancelamento = pessoa.nmPessoa;
            }

        });
    }
    ngOnInit() {
    }

    showPdf() {

        const linkSource = this.viewModelWebContratoEmp.webContratoEmp.nmContratoAssinado;
        if (linkSource !== null) {
            var blob = this.b64toBlob(linkSource, "application/pdf");
            let a = document.createElement("a");
            document.body.appendChild(a);
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = String("contrato" + this.filtro.nrCpf + ".pdf");

            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        } if (linkSource === null) {
            this.openSnackBar("O participante não tem contrato assinado!", 'X');
        }

    }


    processoAcao() {
        this.loading = true;
        this.ValidaData(resultado => {
            if(this.viewModelWebContratoEmp.webContratoEmp.dtCredito == this.viewModelMovimentacaoEmp.dtReferencia){
                this.openSnackBarError("Data referencia incompatível " , 'X');
            }
            else
            if (resultado) {
                this.webProcessoControleService.DeferirProcesso({ idProcesso: this.filtro.idProcesso, idSolicitacao: this.viewModelWebContratoEmp.webContratoEmp.idContratoEmp, idContrato: this.viewModelWebContratoEmp.webContratoEmp.idContratoEmp, idPessoaLogin: this.idPessoaLogada }).subscribe(obj => {
                    // this.isButtonVisible = false;
                    this.loading = false;
                    this.openSnackBar("Processo deferido com sucesso!", 'X');
                }, error => {
                    this.loading = false;
                    this.openSnackBarError("Erro ao deferir!" + error, 'X');
                });
            }
        });
    }

    ValidaData(callback) {
        // let status = true;
         var dia = this.dataAtual.getDate();
         var mes = this.dataAtual.getMonth() + 1;
         var ano = this.dataAtual.getFullYear();
         this.dataFormatada = ano + "-" + (mes < 10 ? ('0' + mes) : mes) + "-" + (dia < 10 ? ('0' + dia) : dia);

        var data1 = this.viewModelWebContratoEmp.webContratoEmp.dtCredito.substring(0,10);

        var date1 = new Date(data1);
        var date2 = new Date(this.dataFormatada);
        
     
        if (date1 <= date2) {
            this.loading = false;
            this.openSnackBar('Deferimento não permitido, a data de crédito já passou', 'Atenção!');
            callback(false);
        }

        else {
            callback(true);
        }
    }

    indeferir() {
        this.loading = true;
        this.webProcessoControleService.IndeferirProcesso({ idProcesso: this.filtro.idProcesso, idSolicitacao: this.viewModelWebContratoEmp.webContratoEmp.idContratoEmp, idContrato: this.viewModelWebContratoEmp.webContratoEmp.idContratoEmp, idPessoaLogin: this.idPessoaLogada }).subscribe(obj => {
            console.log('requisição de indeferimento', obj);
            this.loading = false;
            this.openSnackBar("Processo indeferido com sucesso!", 'X');
        }, error => {
            this.loading = false;
            this.openSnackBarError("Erro ao indeferir!" + error, 'X');
        });

    }

    public b64toBlob(b64Data, contentType) {
        contentType = contentType || '';
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

}

